<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="SAC"
  description="Central de atendimento ao cliente">
</cbc-container>

@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">
  <!-- Card com ação principal -->
  <div class="card mb-lg">
    <div class="card-header">
      <div class="card-title">Atendimento ao Cliente</div>
    </div>
    <div class="card-body">
      Precisa de ajuda? Abra um atendimento e nossa equipe responderá o mais breve possível.
    </div>
    <div class="card-footer">
      <button class="btn btn-primary" (click)="createRegisterCustomerService()">
        Abrir um atendimento
      </button>
    </div>
  </div>

  <!-- Menu de navegação entre abas -->
  <div class="swiper-menu">
    <div class="mini-card-container">
      <div class="mini-card" [class.selected]="selectedTab.value === 'tab1'" (click)="selectedTab.setValue('tab1')">
        <img src="assets/icons/icon_sac_atendimentos_abertos.svg" alt="Atendimentos Abertos" width="40px">
        <span>Atendimentos Abertos</span>
      </div>

      <div class="mini-card" [class.selected]="selectedTab.value === 'tab2'" (click)="selectedTab.setValue('tab2')">
        <img src="assets/icons/icon_sac_atendimentos_fechados.svg" alt="Atendimentos Fechados" width="40px">
        <span>Atendimentos Fechados</span>
      </div>
    </div>
  </div>
</div>

<!-- Conteúdo dos slides -->
<app-swiper swiperContainerId="why-us-swiper">
  <swiper-container #swiper class="swiper" pagination="false" autoplay="false">
    <!-- Slide 1: Atendimentos Abertos -->
    <swiper-slide>
      <div class="slideContainer">
        <ng-container *ngIf="!isMobile; else mobileOpen">
          <!-- Desktop: Tabela -->
          <div class="container">
            @if(getCustomerServiceOpen().length > 0) {
            <div class="card">
              <table mat-table [dataSource]="getCustomerServiceOpen()" class="mat-elevation-z1">
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef>Número do Registro</th>
                  <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                </ng-container>

                <ng-container matColumnDef="subject">
                  <th mat-header-cell *matHeaderCellDef>Assunto</th>
                  <td mat-cell *matCellDef="let element">{{ element.subject || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="registerDateOpen">
                  <th mat-header-cell *matHeaderCellDef>Aberto em</th>
                  <td mat-cell *matCellDef="let element">{{ element.registerDateOpen | date : 'dd/MM/yyyy - HH:mm' }}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let element">
                    <span class="badge badge-primary">{{ element.status! | enumDescription }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="buttons">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element" class="col-actions">
                    <button mat-stroked-button color="primary"
                      (click)="openDialogChat(element.id)">
                      <mat-icon>chat</mat-icon>
                      <span class="button-text">Chat</span>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsOpen"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsOpen"></tr>
              </table>
            </div>
            } @else {
            <div class="card">
              <div class="card-body">
                <p class="text-center text-muted">Nenhum atendimento aberto no momento.</p>
              </div>
            </div>
            }
          </div>
        </ng-container>

        <ng-template #mobileOpen>
          <!-- Mobile: Cards -->
          <div class="container">
            @if(getCustomerServiceOpen().length > 0) {
            <div class="file-container">
              <article *ngFor="let element of getCustomerServiceOpen()" class="file-card" role="group">
                <div class="file-info">
                  <h4 class="file-title">{{ element.subject || '-' }}</h4>
                  <p class="file-name">Registro #{{ element.id }}</p>
                  <div class="file-meta">
                    <p class="file-date">{{ element.registerDateOpen | date : 'dd/MM/yyyy - HH:mm' }}</p>
                    <span class="badge badge-primary">{{ element.status! | enumDescription }}</span>
                  </div>
                </div>
                <div>
                  <button mat-icon-button color="primary"
                    (click)="openDialogChat(element.id!)">
                    <mat-icon>chat</mat-icon>
                  </button>
                </div>
              </article>
            </div>
            } @else {
            <div class="card">
              <div class="card-body">
                <p class="text-center text-muted">Nenhum atendimento aberto no momento.</p>
              </div>
            </div>
            }
          </div>
        </ng-template>
      </div>
    </swiper-slide>

    <!-- Slide 2: Atendimentos Fechados -->
    <swiper-slide>
      <div class="slideContainer">
        <ng-container *ngIf="!isMobile; else mobileClose">
          <!-- Desktop: Tabela -->
          <div class="container">
            @if(getCustomerServiceClose().length > 0) {
            <div class="card">
              <table mat-table [dataSource]="getCustomerServiceClose()" class="mat-elevation-z1">
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef>Número do Registro</th>
                  <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                </ng-container>

                <ng-container matColumnDef="subject">
                  <th mat-header-cell *matHeaderCellDef>Assunto</th>
                  <td mat-cell *matCellDef="let element">{{ element.subject || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="registerDateOpen">
                  <th mat-header-cell *matHeaderCellDef>Aberto em</th>
                  <td mat-cell *matCellDef="let element">{{ element.registerDateOpen | date : 'dd/MM/yyyy - HH:mm' }}</td>
                </ng-container>

                <ng-container matColumnDef="registerDateClose">
                  <th mat-header-cell *matHeaderCellDef>Concluído em</th>
                  <td mat-cell *matCellDef="let element">{{ element.registerDateClose | date : 'dd/MM/yyyy - HH:mm' }}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let element">
                    <span class="badge badge-success">{{ element.status! | enumDescription }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="buttons">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element" class="col-actions">
                    <button mat-stroked-button color="primary"
                      (click)="openDialogChat(element.id)">
                      <mat-icon>chat</mat-icon>
                      <span class="button-text">Chat</span>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsClose"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsClose"></tr>
              </table>
            </div>
            } @else {
            <div class="card">
              <div class="card-body">
                <p class="text-center text-muted">Nenhum atendimento fechado no momento.</p>
              </div>
            </div>
            }
          </div>
        </ng-container>

        <ng-template #mobileClose>
          <!-- Mobile: Cards -->
          <div class="container">
            @if(getCustomerServiceClose().length > 0) {
            <div class="file-container">
              <article *ngFor="let element of getCustomerServiceClose()" class="file-card" role="group">
                <div class="file-info">
                  <h4 class="file-title">{{ element.subject || '-' }}</h4>
                  <p class="file-name">Registro #{{ element.id }}</p>
                  <div class="file-meta">
                    <p class="file-date">
                      Aberto: {{ element.registerDateOpen | date : 'dd/MM/yyyy' }}<br>
                      Concluído: {{ element.registerDateClose | date : 'dd/MM/yyyy' }}
                    </p>
                    <span class="badge badge-success">{{ element.status! | enumDescription }}</span>
                  </div>
                </div>
                <div>
                  <button mat-icon-button color="primary"
                    (click)="openDialogChat(element.id!)">
                    <mat-icon>chat</mat-icon>
                  </button>
                </div>
              </article>
            </div>
            } @else {
            <div class="card">
              <div class="card-body">
                <p class="text-center text-muted">Nenhum atendimento fechado no momento.</p>
              </div>
            </div>
            }
          </div>
        </ng-template>
      </div>
    </swiper-slide>
  </swiper-container>
</app-swiper>
}